import { render } from "./ComponenteGasPreciosPlanificacion.vue?vue&type=template&id=32bfb68b&scoped=true"
import script from "./ComponenteGasPreciosPlanificacion.vue?vue&type=script&lang=js"
export * from "./ComponenteGasPreciosPlanificacion.vue?vue&type=script&lang=js"

import "./ComponenteGasPreciosPlanificacion.vue?vue&type=style&index=0&id=32bfb68b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bfb68b"]])

export default __exports__